import axios from 'axios';
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_API_URL;

export const getBusinessQrCodeUrl = async (businessId) => {
    try {
        const response = await axios.get(`${API_URL}/business/${businessId}/qr-code-url`, {
            withCredentials: true,
            headers: {
                'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
            },
        });
        const url = response.data?.qrCodeUrl;
        return typeof url === 'string' ? url : '';
    } catch (error) {
        console.error('Error fetching business QR code URL:', error);
        throw error;
    }
};

export const downloadBusinessQRCode = async (businessId) => {
    try {
        const response = await axios.get(`${API_URL}/business/${businessId}/qr-code`, {
            responseType: 'blob',
            withCredentials: true,
            headers: {
                'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error downloading QR code:', error);
        throw error;
    }
};
